export enum ACTIONS {
  getAll = 'getAll',
  LOGIN = 'Login',
  add = 'add',
  Edit = 'Edit',
  delete = 'delete',
  GET_DOCTORS = 'GetDoctors',
  GET_DOCTOR_CENTER = 'GetDoctorCenters',
  GET_DOCTOR_TIMES = 'GetDoctorTimes',
  SendConfirmationCode = 'SendConfirmationCode',
  ReserveTime = 'ReserveTime',
  AddPatientReserveTime = 'AddPatientReserveTime',
  GetUserInfo = 'GetUserInfo',
  ValidateReserveTime = 'ValidateReserveTime',
  GetPatientReceptions = 'GetPatientReceptions',
  updateReceptionTrackingCode = 'updateReceptionTrackingCode',
  GetSetting = 'GetSetting',
  GetPatients = 'GetPatients',
  GetDoctorSecretaries = 'GetDoctorSecretaries',
  GetWaitingVisit = 'GetWaitingVisit',
  ClearWaitingVisit = 'ClearWaitingVisit',
  GetPatient = 'GetPatient',
  GetTaminDrugs = 'GetTaminDrugs',
  RemoveTaminDrugs = 'RemoveTaminDrugs',
  GetSalamatDrugs = 'GetSalamatDrugs',
  RemoveSalamatDrugs = 'RemoveSalamatDrugs',
  aggregationOfInstructions = 'AggregationOfInstructions',
  QuickSearchDrugWithGeneric = 'QuickSearchDrugWithGeneric',
  QuickSearchDrugWithIrc = 'QuickSearchDrugWithIrc',
  AddSalamatDrug = 'AddSalamatDrug',
  savePrescription = 'savePrescription',
  checkOrder = 'checkOrder',
  updateReceptionIsVisitedStatus = 'updateReceptionIsVisitedStatus',
  GetTaminParaClinics = 'GetTaminParaClinics',
  RemoveTaminParaClinc = 'RemoveTaminParaClinc',
  AddSalamatParaClinic = 'AddSalamatParaClinic',
  GetSalamatParaClinics = 'GetSalamatParaClinics',
  RemoveSalamatParaClinics = 'RemoveSalamatParaClinics',
  ServiceSearch = 'ServiceSearch',
  GetDeliveredSamadCodes = 'GetDeliveredSamadCodes',
  CheckDeliveredOrder = 'CheckDeliveredOrder',
  UpdatePrescription = 'UpdatePrescription',
  GetPrescriptionBySamadCode = 'GetPrescriptionBySamadCode',
  GetPrescriptionByPrintCode = 'GetPrescriptionByPrintCode',
  GetSamadOrderedList = 'GetSamadOrderedList',
  DeliverPrescription = 'DeliverPrescription',
  HasMetric = 'HasMetric',
  CreateCitizenSession = 'CreateCitizenSession',
  RegistrationPrescription = 'RegistrationPrescription',
  RegistrationParaclinicPrescription = 'RegistrationParaclinicPrescription',
  GetPrescription = 'GetPrescription',
  GetLaboratoryPrescription = 'GetLaboratoryPrescription',
  EditPrescription = 'EditPrescription',
  EditLaboratoryPrescription = 'EditLaboratoryPrescription',
  DeletePrescription = 'DeletePrescription',
  HastMetric = 'HastMetric',
  SearchTaminDrugs = 'TaminDrugs',
  SearchTaminParaClinic = 'TaminParaClinic',
  GetDoctorServices = 'GetDoctorServices',
  GetDoctorService = 'GetDoctorService',
  GetDoctorServiceMaterials = 'GetDoctorServiceMaterials',
  CalculateReceptionAmount = 'CalculateReceptionAmount',
  CalculateReceptionAmountForAssistant = 'CalculateReceptionAmountForAssistant',
  AddReception = 'AddReception',
  GetReception = 'GetReception',
  GetReceptionServices = 'GetReceptionServices',
  GetReceptionMaterials = 'GetReceptionMaterials',
  GetReceptionByCustomId = 'GetReceptionByCustomId',
  UpdateReception = 'UpdateReception',
  UpdateReceptionReasonForReferenceId = 'UpdateReceptionReasonForReferenceId',
  RevokeReception = 'RevokeReception',
  GetDoctorServiceMaterial = 'GetDoctorServiceMaterial',
  GetMaterialInsuranceAmounts = 'GetMaterialInsuranceAmounts',
  GetMaterialInsuranceAmount = 'GetMaterialInsuranceAmount',
  AddTaminDrugs = 'AddTaminDrug',
  AddTaminParaClinic = 'AddTaminParaClinic',
  AddPrescribeDrug = 'AddPrescribeDrug',
  getPrescribedDrugs = 'GetPrescribedDrugs',
  AddPrescribeLaboratory = 'AddPrescribeLaboratory',
  GetConsummationInstructions = 'GetConsumptionInstructions',
  GetConsummationSize = 'GetConsumptionSize',
  GetParaClinicTypes = 'GetParaClinicTypes',
  GetConsumptionInstructions = 'GetConsumptionInstructions',
  GetUsages = 'GetUsages',
  GetConsumptionSize = 'GetConsumptionSize',
  GetDepartments = 'GetDepartments',
  GetGalleryImageTypes = 'GetGalleryImageTypes',
  GetGalleries = 'GetGalleries',
  AddGallery = 'AddGallery',
  InsuranceEntity = 'GetInsurances',
  BloodLinesEntity = 'GetBloodType',
}
